





















































import {Vue, Component} from 'vue-property-decorator'
import getConnection from "@/utils/signalr_connection";

@Component({})
export default class Visits extends Vue {

  recentVisits = [];

  async created() {
    getConnection().on('visitsChanged', this.getRecentVisits);
    await this.getRecentVisits();
  }

  async getRecentVisits() {
    const {data} = await this.$http.get("/api/GetRecentVisits");
    this.recentVisits = data;
  }

  destroyed() {
    getConnection().off('visitsChanged', this.getRecentVisits);
  }
}
